import { encryptedRequest } from "../auth/api";
import { API_PATHS } from "../constants/api.constants";

export interface ILeadsResponse {
  data: {
    flag: string;
  };
  statusCode: number;
  status: "success" | "error";
  message: string;
}

export const leadsBuySell = async (payload: string) => {
  const response: ILeadsResponse = await encryptedRequest({
    method: "POST",
    url: API_PATHS.leads,
    data: {
      mobileNo: payload,
    },
  });
  return response;
};
